export default __webpack_public_path__ + "static/media/advantage2.386d206a.png";